export const environment = {
  production: false,
  base_url: 'https://devapi.nsicc.ca/api',
  recaptcha: {
    siteKey: '6LcDyEspAAAAADEz6FrX5kYgBfnuxffSG9DYRjIp',
  },
};
